import { useEffect, useRef, useState } from "react";
import { useAssessment } from "../components/AssessmentProvider";
import { useAuth } from "../components/AuthProvider";
import { apiFetch } from "../services/api";
import { useLocation } from "react-router-dom";
import { useRuntimeConfig } from "../contexts/RuntimeConfigContext";

export function useTaskListStats() {
  const { tokens } = useAuth();
  const { selected } = useAssessment();
  const { features } = useRuntimeConfig();
  const [taskCount, setTaskCount] = useState<number | null>(null);
  const location = useLocation();
  const fetchedOnce = useRef(false);
  const taskListEnabled = features.task_list !== false;

  useEffect(() => {
    let active = true;
    if (!taskListEnabled || !selected?.id || !tokens?.access_token) {
      setTaskCount(null);
      fetchedOnce.current = false;
      return;
    }
    const shouldRefresh = location.pathname.startsWith("/workspace/task-list") || !fetchedOnce.current;
    if (!shouldRefresh) {
      return;
    }
    fetchedOnce.current = true;

    const load = async () => {
      try {
        const payload = await apiFetch<{ items: Array<{ severity: string }> }>(
          `/assessments/${selected.id}/tasklist`,
          { method: "GET" },
          tokens.access_token
        );
        if (!active) return;
        const tasksOnly = payload.items?.filter((item) => item.severity === "tasks") ?? [];
        setTaskCount(tasksOnly.length);
      } catch {
        if (active) {
          setTaskCount(null);
        }
      }
    };

    void load();
    return () => {
      active = false;
    };
  }, [taskListEnabled, selected?.id, tokens?.access_token, location.pathname]);

  return taskCount;
}
